import { Component, Input } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../../environments/environment';
import { ReferComponent } from '../../modals/refer/refer.component';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { PopupService } from '../../services/popup.service';
import { CHAINS, convertNum } from '../../shared/constants/app-enums';
import { ICounter } from '../../shared/interfaces/common.interface';

@Component({
  selector: 'app-round-user-details',
  templateUrl: './round-user-details.component.html',
  styleUrl: './round-user-details.component.scss',
})

// This component is used to show the Round timer, User purchased details, Round title etc
export class RoundAndUserDetails {
  // Values to be taken from widget component
  @Input() liveCounter: ICounter = {
    _days: 0,
    _hours: 0,
    _minutes: 0,
    _seconds: 0,
    _diff: 0,
  };
  @Input() raisedInfo: {
    usdRaised: number;
    raisedPercent: string;
    userStaked: number;
    userEthClaimable: number;
    userClaimable: number;
    maxAmount: number;
  } = {
      raisedPercent: '',
      usdRaised: 0,
      userClaimable: 0,
      userEthClaimable: 0,
      userStaked: 0,
      maxAmount: 0,
    };
  @Input() salePrice: number = 0;
  // Values to be taken from widget component
  tokenName = environment.tokenName;
  modalRef!: BsModalRef<ReferComponent>;
  walletAddress: string = '';
  usdRaisedFixed = 2393939.58;

  constructor(
    private dataService: PresaleDataService,
    private popupService: PopupService,
    private translate: TranslateService,
    private modalService: BsModalService,
  ) {
    this.dataService.$walletAddress.subscribe({
      next: (address: string) => {
        this.walletAddress = this.dataService?.activeChain === CHAINS.SOL ? this.dataService.walletAddressSOL : this.dataService.walletAddress
      }
    })
  }

  get saleToken() {
    return this.dataService.saleToken;
  }

  convertNum(amount: number, decimal = 2) {
    if (!amount) return 0;
    return convertNum(amount, decimal);
  }

  yourPurchasedInfo() {
    this.popupService.messagePopup({
      icon: 'info',
      desc: this.translate.instant('popup.your_purchased_popup_info'),
      confirmBtnTxt: this.translate.instant('misc.ok'),
    });
  }

  get isReferalAvailable() {
    return this.dataService.isReferalAvailable;
  }

  referAndEarn(): void {
    this.modalRef = this.modalService.show(ReferComponent, {
      class: 'modal-min modal-dialog-centered',
      backdrop: 'static',
    });
  }
}
